import { ConfigProvider, App as AntApp } from "antd";
import customTheme from "./config/theme";
import { UserProvider } from "./contexts/UserContext";
import { AppRoutes } from "./routes/index";
import "antd/dist/reset.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";

function App() {
  return (
    <ConfigProvider theme={customTheme}>
      <AntApp>
        <UserProvider>
          <div className="App">
            <AppRoutes />
          </div>
        </UserProvider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
